import { useQuery } from '@tanstack/react-query';

import { janeApiV2 } from '@jane/shared/data-access';

const fetchPosTags = async (
  storeId: string,
  query: string
): Promise<string[]> => {
  const url = `/business/stores/${storeId}/pos_tags?q=${encodeURIComponent(query)}`;
  const data = await janeApiV2.get<string[]>(url);
  return data;
};

export const usePosTagsSearch = (storeId: string, query: string) => {
  return useQuery<string[]>({
    queryFn: () => fetchPosTags(storeId, query),
    queryKey: ['posTags', storeId, query],
    enabled: query.length > 0,
  });
};
